import React, { Component } from "react";
import { get as _get } from "lodash";

export default class MapsLinks extends Component {
  getWaypoints() {
    const { crew } = this.props;
    const office = crew.office || {};
    const origin = `${office.lat},${office.lon}`;

    if (crew.route_to_all_sites) {
      const sites = _get(crew, "canvassers[0].sites", []);
      const waypoints = sites.map(
        (s) => `${s.latitude},${s.longitude}`
      );
      return { origin, destination: origin, waypoints };
    }

    const canvassers = (crew.canvassers || []).filter((c) => c.dropoff);
    if (!canvassers.length) return { origin, destination: origin, waypoints: [] };

    const lastCanvasser = canvassers[canvassers.length - 1];
    const destination = `${lastCanvasser.dropoff.latitude},${lastCanvasser.dropoff.longitude}`;

    const waypoints = canvassers.slice(0, -1).map(
      (c) => `${c.dropoff.latitude},${c.dropoff.longitude}`
    );

    return { origin, destination, waypoints };
  }

  buildGoogleMapsUrl() {
    const { origin, destination, waypoints } = this.getWaypoints();
    let url = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`;
    if (waypoints.length) {
      url += `&waypoints=${waypoints.join("|")}`;
    }
    return url;
  }

  buildAppleMapsUrl() {
    const { origin, destination, waypoints } = this.getWaypoints();
    let url = `https://maps.apple.com/?saddr=${origin}&daddr=${destination}&dirflg=d`;
    if (waypoints.length) {
      url += `&waypoints=${waypoints.join("|")}`;
    }
    return url;
  }

  render() {
    return (
      <div className="maps-links no-print">
        <a
          href={this.buildGoogleMapsUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="maps-link--google"
        >
          Open in Google Maps
        </a>
        <a
          href={this.buildAppleMapsUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="maps-link--apple"
        >
          Open in Apple Maps
        </a>
      </div>
    );
  }
}
